import { Link } from 'react-router-dom';
import backSvg from '../back.svg';

function ChartHeader() {
    return (
        <div className='fixed top-2 left-2 z-50'>
            <Link to="/" className="flex items-center justify-center w-10 h-10 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-transform hover:scale-105 border border-gray-200">
                 <img src={backSvg} alt="Back" className="w-6 h-6" />
            </Link>
        </div>
    )
}

export default ChartHeader;
